// MALABISthestic Product Catalog Data
// Purpose: Marketing website showcasing designs - quality and size depend on customer

export const categories = [
  {
    id: 'hotel',
    name: 'Hotel Staff',
    description: 'Premium uniform designs for hospitality excellence',
    image: '/productimages/img1.jpeg'
  },
  {
    id: 'hospital',
    name: 'Hospital Staff',
    description: 'Professional medical attire designs for healthcare',
    image: '/productimages/img24.jpeg'
  }
];

export const subCategories = {
  hotel: [
    { id: 'front-desk', name: 'Front Desk' },
    { id: 'hod', name: 'H.O.D' },
    { id: 'bartender', name: 'Bartender ' },
    { id: 'aprons', name: 'Aprons' },
    { id: 'executive-chef', name: ' Chef Designs' },
    { id: 'housekeeping', name: 'Housekeeping' },
    { id: 'fnb', name: 'F & B' },
    { id: 'waist-coat', name: 'Waist Coat' },
    { id: 'security', name: 'Security Dress' }
  ],
  hospital: [
    { id: 'lab', name: 'Lab Coat ' },
    { id: 'scrube', name: 'scrubs suit' }
  ]
};

export const products = [
  // Hotel - Front Desk
  {
    id: 'fd-001',
    name: ' Front Desk ',
    category: 'hotel',
    subCategory: 'front-desk',
    description: 'Elegant blazer design for front desk staff. Available as per your measurement and selected colour.',
    images: ['/productimages/newfrontdesk1.jpeg', '/productimages/newfrontdesk2.jpeg', '/productimages/newfrontdesk3.jpeg', '/productimages/newfrontdesk4.jpeg','/productimages/newfrontdesk5.jpeg','/productimages/newfrontdesk6.jpeg','/productimages/newfrontdesk7.jpeg',],
    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Professional look'],
    customization: true
  },


  // Hotel - H.O.D
  {
    id: 'hod-001',
    name: ' H.O.D Suit',
    category: 'hotel',
    subCategory: 'hod',
    description: 'Premium executive suit design for department heads. Crafted as per your specifications.',
    images: ['/productimages/Hod1.jpeg', '/productimages/Hod2.jpeg', '/productimages/Hod3.jpeg', '/productimages/Hod4.jpeg','/productimages/Hod5.jpeg','/productimages/Hod6.jpeg','/productimages/Hod9.jpeg'],

    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Executive look'],
    customization: true
  },
  

  // Hotel - bartender
  {
    id: 'bartender-001',
    name: 'Bartender ',
    category: 'hotel',
    subCategory: 'bartender',
    description: 'Bartender design. Available as per your measurement and colour preference.',

    images: ['/productimages/bartender1.jpeg', '/productimages/bartender2.jpeg', '/productimages/bartender3.jpeg', '/productimages/bartender4.jpeg','/productimages/bartender5.jpeg','/productimages/bartender6.jpeg',],
    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Classic culinary style'],
    customization: true
  },


  // Hotel - Aprons
  {
    id: 'apron-001',
    name: ' Apron',
    category: 'hotel',
    subCategory: 'aprons',
    description: 'Traditional apron design. Available as per your measurement and colour selection.',
        images: ['/productimages/apron1.jpeg', '/productimages/apron2.jpeg', '/productimages/apron3.jpeg', '/productimages/apron5.jpeg','/productimages/apron6.jpeg',],

    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Classic style'],
    customization: true
  },
 

  // Hotel - Executive Chef Designs
  {
    id: 'exec-chef-001',
    name: ' Chef Coat',
    category: 'hotel',
    subCategory: 'executive-chef',
    description: 'Premium executive chef design. Available as per your measurement and colour preference.',
    images: ['/productimages/chefcoat1.jpeg', '/productimages/chefcoat2.jpeg', '/productimages/chefcoat3.jpeg', '/productimages/chefcoat4.jpeg','/productimages/chefcoat5.jpeg','/productimages/chefcoat6.jpeg','/productimages/chefcoat7.jpeg','/productimages/chefcoat8.jpeg','/productimages/chefcoat9.jpeg','/productimages/chefcoatapron7.jpeg'],
    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Executive culinary style'],
    customization: true
  },
  

  // Hotel - Housekeeping
  {
    id: 'hk-001',
    name: ' Housekeeping Dress',
    category: 'hotel',
    subCategory: 'housekeeping',
    description: 'Elegant housekeeping uniform design. Available as per your measurement and colour.',
    images: ['/productimages/newhousekeeping1.jpeg ', '/productimages/newhousekeeping2.jpeg', '/productimages/newhousekeeping3.jpeg', '/productimages/newhousekeeping4.jpeg','/productimages/newhousekeeping5.jpeg ','/productimages/newhousekeeping6.jpeg ','/productimages/newhousekeeping7.jpeg ','/productimages/newhousekeeping8.jpeg ','/productimages/newhousekeeping9.jpeg ',],
    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Classic elegance'],
    customization: true
  },
  

  // Hotel - F & B
  {
    id: 'fnb-001',
    name: 'Server Formal Design',
    category: 'hotel',
    subCategory: 'fnb',
    description: 'Elegant server uniform design. Available as per your measurement and colour selection.',
    images: ['/productimages/f&b1.jpeg ', '/productimages/f&b2.jpeg', '/productimages/f&b3.jpeg', '/productimages/f&b4.jpeg','/productimages/f&b5.jpeg ','/productimages/f&b6.jpeg ','/productimages/f&b7.jpeg ','/productimages/f&b8.jpeg ','/productimages/f&b9.jpeg ','/productimages/f&b10.jpeg ','/productimages/f&b11.jpeg ',],
    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Service elegance'],
    customization: true
  },
 

  // Hotel - Waist Coat
  {
    id: 'wc-001',
    name: 'Our Waist Coat Design ',
    category: 'hotel',
    subCategory: 'waist-coat',
    description: 'Traditional waist coat design. Available as per your measurement and colour.',
    images: ['/productimages/Waist coat1.jpeg ', '/productimages/Waist coat2.jpeg ', '/productimages/Waist coat3.jpeg ', '/productimages/Waist coat4.jpeg','/productimages/Waist coat5.jpeg ','/productimages/Waist coat6.jpeg ','/productimages/Waist coat7.jpeg ','/productimages/Waist coat8.jpeg ','/productimages/Waist coat9.jpeg ','/productimages/Waist coat10.jpeg ',],
    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Classic style'],
    customization: true
  },
  
  // Hotel - Security Dress
  {
    id: 'sec-001',
    name: 'Security Uniform Design',
    category: 'hotel',
    subCategory: 'security',
    description: 'Professional security uniform design. Available as per your measurement and colour.',
    images: ['/productimages/securety1.jpeg', '/productimages/securety2.jpeg', '/productimages/securety3.jpeg', '/productimages/securety4.jpeg','/productimages/securety5.jpeg','/productimages/security6.jpeg'],
    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Professional security'],
    customization: true
  },
  

  // Hospital - Lab Technicians
  {
    id: 'lab-001',
    name: 'Lab Coat Design',
    category: 'hospital',
    subCategory: 'lab',
    description: 'Professional lab coat design. Available as per your measurement and colour.',
    images: ['/productimages/labcoat1.jpeg', '/productimages/labcoat2.jpeg', '/productimages/labcoat3.jpeg ','/productimages/labcoat4.jpeg','/productimages/labcoat5.jpeg','/productimages/labcoat6.jpeg'],
    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Lab professional'],
    customization: true
  },


   // Hospital - scubesuit
   {
    id: 'scrube-001',
    name: 'scrube suit Design',
    category: 'hospital',
    subCategory: 'scrube',
    description: 'Professional scrubs suit design. Available as per your measurement and colour.',
    images: ['/productimages/scrubesuit1.jpeg', '/productimages/scrubesuit2.jpeg', '/productimages/scrubesuit3.jpeg ','/productimages/scrubesuit4.jpeg'],
    features: ['Custom design', 'As per your measurement', 'As per your selected colour', 'Lab professional'],
    customization: true
  },
  
];

export const getProductById = (id) => {
  return products.find(product => product.id === id);
};

export const getProductsByCategory = (categoryId) => {
  return products.filter(product => product.category === categoryId);
};

export const getProductsBySubCategory = (categoryId, subCategoryId) => {
  return products.filter(
    product => product.category === categoryId && product.subCategory === subCategoryId
  );
};

export const searchProducts = (query) => {
  const lowercaseQuery = query.toLowerCase();
  return products.filter(
    product =>
      product.name.toLowerCase().includes(lowercaseQuery) ||
      product.description.toLowerCase().includes(lowercaseQuery) ||
      product.category.toLowerCase().includes(lowercaseQuery) ||
      product.subCategory.toLowerCase().includes(lowercaseQuery)
  );
};

// Get related products (same subcategory)
export const getRelatedProducts = (productId, limit = 4) => {
  const product = getProductById(productId);
  if (!product) return [];

  return products
    .filter(p => p.subCategory === product.subCategory && p.id !== productId)
    .slice(0, limit);
};
